import { render, staticRenderFns } from "./articlePage.vue?vue&type=template&id=02cb40e8&scoped=true&"
import script from "./articlePage.vue?vue&type=script&lang=js&"
export * from "./articlePage.vue?vue&type=script&lang=js&"
import style0 from "./articlePage.vue?vue&type=style&index=0&id=02cb40e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb40e8",
  null
  
)

export default component.exports